module.exports = __webpack_public_path__ + "static/media/implement.87f60612.svg";